import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Cookies from 'js-cookie'

export const registerUser = createAsyncThunk(
  'auth/registerUser',
  async (
    userDetails: {
      username: string
      password: string
      firstName: string
      lastName: string
      email: string
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/auth/register`,
        {
          username: userDetails.username,
          email: userDetails.email,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          password: userDetails.password,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      )
      if (response.status === 201) {
        const { token } = response.data
        localStorage.setItem('token', token || '')
        localStorage.setItem('username', userDetails.username || '')
        Cookies.set('token', token, {
          expires: 7,
          secure: true,
          sameSite: 'Strict',
        })
        Cookies.set('username', userDetails.username, {
          expires: 7,
          secure: true,
          sameSite: 'Strict',
        })

        return {
          authenticated: true,
          username: userDetails.username,
          token,
        }
      } else {
        return rejectWithValue('Registration failed')
      }
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.error || 'Registration failed'
      )
    }
  }
)
